export enum UserRegistrationStatusEnum {
  Inited = 'inited',
  Verified = 'verified',
  Rejected = 'rejected',
}
